import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import CrudPage from "@/components/admin/CrudPage";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const STATUS = { jamaah: "bg-emerald-100 text-emerald-800", donatur: "bg-[#f6ebd0] text-[#8a6d14]", mustahik: "bg-sky-100 text-sky-800" };

const fields = [
  { name: "name", label: "Nama Lengkap", required: true },
  { name: "gender", label: "Jenis Kelamin", type: "select", options: [{ value: "L", label: "Laki-laki" }, { value: "P", label: "Perempuan" }] },
  { name: "rt", label: "RT" },
  { name: "rw", label: "RW" },
  { name: "phone", label: "No. HP / WA" },
  { name: "status", label: "Status", type: "select", options: [{ value: "jamaah", label: "Jamaah" }, { value: "donatur", label: "Donatur" }, { value: "mustahik", label: "Mustahik (Penerima Zakat)" }] },
  { name: "address", label: "Alamat", type: "textarea" },
  { name: "notes", label: "Catatan", type: "textarea" },
];

const columns = [
  { key: "name", label: "Nama", className: "font-medium" },
  { key: "gender", label: "L/P" },
  { key: "rt", label: "RT/RW", render: (j) => `${j.rt}/${j.rw}` },
  { key: "phone", label: "Kontak", className: "text-slate-500" },
  { key: "status", label: "Status", render: (j) => <Badge className={`${STATUS[j.status] || ""} capitalize`}>{j.status}</Badge> },
];

export default function JamaahPage() {
  return (
    <CrudPage
      title="Data Jamaah"
      subtitle="Database jamaah, donatur, dan mustahik Dusun Banjarwaru"
      endpoint="jamaah"
      prefix="admin-jamaah"
      itemLabel="Jamaah"
      fields={fields}
      columns={columns}
      defaults={{ name: "", gender: "L", rt: "05", rw: "06", phone: "", status: "jamaah", address: "", notes: "" }}
      searchKeys={["name", "phone", "status", "address"]}
      rowActions={(j) => (
        <Button asChild variant="ghost" size="icon" data-testid={`admin-jamaah-detail-${j.id}`}>
          <Link to={`/admin/jamaah/${j.id}`} aria-label="Detail"><Eye size={15} /></Link>
        </Button>
      )}
    />
  );
}
